import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, ButtonGroup, Container, Modal, ModalBody, ModalHeader } from 'reactstrap';
import styled from 'styled-components';
import { getPhysiotherapyRequest, requestPhysiotherapyPayment, resendCashlessLetter, generateCashlessLetter } from '../../../services/api/cashless-physiotherapy-v2';
import ConfirmationModal from '../../common/ConfirmationModal';
import LoadingComponent from '../../common/LoadingComponent';
import { BoldText } from '../../common/Text';
import OrderStatus from '../components/OrderStatus';
import RequestRow from './RequestRow';
const DetailsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

const SectionContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const SectionInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.625rem;
`;

const SectionHeader = styled(BoldText)`
  font-size: 1.2rem;
  color: #4b4f5b;
`;

const SectionBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 0.625rem;
`;

const SpocDetailContainer = styled(SectionContainer)`
  background-color: #f8f9fa;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  padding: 0.625rem;
`;

const PhysiotherapyRequestDetails = ({
    details,
    onClose,
    isOpen
}) => {
    const [vaccineInfo, setVaccineInfo] = useState({})
    const [activeInfo, setActiveInfo] = useState('basic')
    const [basicInfo, setBasicInfo] = useState({})
    const [payInfo, setPayInfo] = useState({})
    const [spocInfo, setSpocInfo] = useState({})
    const [reqPaymentLoading, setReqPaymentLoading] = useState(false)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [confirmMessage, setConfirmMessage] = useState('')
    const [transactions, setTransactions] = useState([])
    const [generateLetterLoading, setGenerateLetterLoading] = useState(false)

    useEffect(() => {
        if (details.requestId) {
            findRequestInformation(details.requestId)
            // findTransactionHistory(details.requestId)
        }
    }, [details.requestId])

    const findRequestInformation = (requestId) => {
        getPhysiotherapyRequest(requestId)
        .then((response) => {
            setBasicInfo(response.basicInfo)
        })
    }

    const resendPhysiotherapyLetter = () => {
        const { requestId } = details
        return resendCashlessLetter(requestId)
        .then((response) => {
            if (response.message === 'success') {
                return toast.success('Cashless letter resent successfully')
            }
            toast.error('Error while sending cashless letter')
        })
        .catch((err) => {
            console.log({err})
            toast.error('Error while sending cashless letter')
        })
    }

    const renderTimeline = () => (
        <DetailsContainer>
            <SectionContainer>
                <SectionHeader>Physiotherapy Booking Timeline</SectionHeader>
                <SectionBody>
                    <OrderStatus
                        requestId={details.requestId}
                    />
                </SectionBody>
            </SectionContainer>
        </DetailsContainer>
    )

    const renderBasicInfo = () => (
        <DetailsContainer>
            <SectionContainer>
                <SectionInnerContainer>
                    <SectionHeader>User Booking Details</SectionHeader>
                    <SectionBody>
                        <RequestRow name='User Id:' value={basicInfo.userId} />
                        <RequestRow name='Patient Name:' value={basicInfo.patientName} />
                        <RequestRow name='Patient Relation:' value={basicInfo.patientRelation} />
                        <RequestRow name='Patient DOB:' value={basicInfo.patientDob} />
                        <RequestRow name='User Email:' value={basicInfo.userEmail} />
                        <RequestRow name='User Phone:' value={basicInfo.userPhone} />
                    </SectionBody>
                </SectionInnerContainer>
                <SectionInnerContainer>
                    <SectionHeader>Consultation Details</SectionHeader>
                    <SectionBody>
                        <RequestRow name='Appointment Id:' value={basicInfo.requestId} />
                        <RequestRow name='Appointment Date:' value={basicInfo.appointmentDate} />
                        <RequestRow name='Appointment Slot:' value={basicInfo.appointmentTime} />
                        <RequestRow name='Requested Appointment Date:' value={basicInfo.requestedAppointmentDate} />
                        <RequestRow name='Requested Appointment Slot:' value={basicInfo.requestedAppointmentTime} />
                        <RequestRow name='Consultation Amount:' value={basicInfo.consultationAmount} />
                    </SectionBody>
                </SectionInnerContainer>
            </SectionContainer>
            <SectionContainer>
                <SectionInnerContainer>

                <SectionHeader>Physiotherapy Booking Details</SectionHeader>
                <SectionBody>
                    <RequestRow name='Center Name:' value={basicInfo.centerName} />
                    <RequestRow name='Center Address:' value={basicInfo.centerAddress} />
                    <RequestRow name='Center Id' value={basicInfo.centerId} />
                </SectionBody>
                </SectionInnerContainer>

                <SectionInnerContainer>

                <SectionHeader>Session Details</SectionHeader>
                <SectionBody>
                    <RequestRow name='Request Valid Till:' value={basicInfo.validTill} />
                    <RequestRow name='Sessions Approved:' value={basicInfo.sessionsApproved} />
                    <RequestRow name='Package Name:' value={basicInfo.packageName} />
                    <RequestRow name='Sessions Booked:' value={basicInfo.sessionsBooked} />
                    <RequestRow name='Sessions Taken:' value={basicInfo.sessionsTaken} />
                    <RequestRow name='Cart Amount:' value={basicInfo.cartAmount} />
                </SectionBody>
                </SectionInnerContainer>
            </SectionContainer>
        </DetailsContainer>
    )

    const yesNo = value => value ? 'Yes' : 'No'

    const renderCenterInfo = () => (
        <DetailsContainer>
            <SectionContainer>
                <SectionInnerContainer>
                    <SectionHeader>Center Details:</SectionHeader>
                    <SectionBody>
                        <RequestRow name='Practice Center:' value={basicInfo.centerName} />
                        <RequestRow name='Location:' value={basicInfo.centerAddress} />
                        <RequestRow name='City:' value={basicInfo.centerCity} />
                        <RequestRow name='Locality:' value={basicInfo.centerLocality} />
                        <RequestRow name='Visit SPOC:' value={basicInfo.visitSpoc} />
                    </SectionBody>
                </SectionInnerContainer>
            </SectionContainer>

            <SectionContainer>
                <SectionInnerContainer>
                    <SectionHeader>SPOC Details</SectionHeader>
                    <SectionBody>
                        {Array.isArray(spocInfo) ? 
                            spocInfo.map(item => {
                                return <SpocDetailContainer>
                                    <RequestRow name='Name:' value={`${item.name} (${item.type})`} />
                                    <RequestRow name='Email:' value={item.email} />
                                    <RequestRow name='Phone:' value={item.phone} />
                                    <RequestRow name='Comm. Type:' value={item.commType} />
                                    <RequestRow name='Send WhatsApp:' value={yesNo(item.sendWhatsApp)} />
                                    <RequestRow name='Send Email:' value={yesNo(item.sendEmail)} />
                                    <RequestRow name='Send CC:' value={yesNo(item.sendCC)} />
                                    <RequestRow name='Send SMS:' value={yesNo(item.sendSMS)} />
                                    <RequestRow name='Send Call:' value={yesNo(item.sendCall)} />
                                </SpocDetailContainer>
                            })
                        : <></>}
                    </SectionBody>
                </SectionInnerContainer>
            </SectionContainer>
        </DetailsContainer>
    )

    const handleGenerateCashlessLetter = () => {
        const { requestId } = details
        setGenerateLetterLoading(true)
        return generateCashlessLetter(requestId)
        .then((response) => {
            if (response.message === 'success') {
                return toast.success('Cashless letter generated successfully')
            }
            toast.error('Error while generating cashless letter')
        })
        .catch((err) => {
            console.log({err})
            toast.error('Error while generating cashless letter')
        })
        .finally(() => {
            setGenerateLetterLoading(false)
        })
    }

    const renderActions = () => (
        <DetailsContainer>
            <SectionContainer>
                <SectionInnerContainer>
                    <SectionHeader>Actions</SectionHeader>
                    <SectionBody>
                        <Button
                            color="primary"
                            onClick={handleGenerateCashlessLetter}
                            disabled={generateLetterLoading}
                        >
                            {generateLetterLoading ? 'Generating...' : 'Generate Cashless Letter'}
                        </Button>
                    </SectionBody>
                </SectionInnerContainer>
            </SectionContainer>
        </DetailsContainer>
    )

    const handleRequestSubmit = () => {
        const { requestId } = details
        return requestPhysiotherapyPayment(requestId)
        .then((response) => {
            console.log(response);
            if (response.message === 'success') {
                return toast.success('Payout requested successfully')
            }
            toast.error(response.errorMessage);
        })
        .catch((err) => {
            toast.error('Error while requesting payout')
        })
        .finally(() => {
            setShowConfirmModal(false)
            setReqPaymentLoading(false)
        })
    }

    if (!isOpen) {
        return <></>
    }

    if (!basicInfo || !details.requestId) {
        return <LoadingComponent color="black" />;
    }

    if (basicInfo && details.requestId) {
        return <Modal
            isOpen={details.showRequestDetails}
            toggle={onClose}
            size='lg'
            className='rtsp-modal-big'
        >
            <ModalHeader
                className='bg-primary'
                toggle={onClose}
            >
                {`Request Details (${details.requestId})`}
            </ModalHeader>
            <ModalBody>
                <Container fluid>
                    <div className='row'>
                        <ButtonGroup>
                            <Button
                                onClick={() => setActiveInfo('basic')}
                                active={activeInfo === 'basic'}
                            >
                                Basic Info
                            </Button>
                            <Button
                                onClick={() => setActiveInfo('center')}
                                active={activeInfo === 'center'}
                            >
                                Center Info
                            </Button>
                            <Button
                                onClick={() => setActiveInfo('actions')}
                                active={activeInfo === 'actions'}
                            >
                                Actions
                            </Button>
                        </ButtonGroup>
                    </div>
                    <div className='row'>
                        <div className='col-md-8'>
                            {activeInfo === 'basic' && renderBasicInfo()}
                            {activeInfo === 'center' && renderCenterInfo()}
                            {activeInfo === 'actions' && renderActions()}
                        </div>
                        <div className='col-md-4'>
                            {renderTimeline()}
                        </div>
                    </div>
                    <ConfirmationModal 
                        isOpen={showConfirmModal}
                        confirmationMessage={confirmMessage}
                        callback={handleRequestSubmit}
                        toggle={() => setShowConfirmModal(prev => !prev)}
                    />
                </Container>
            </ModalBody>
        </Modal>
    } else {
        return <div />
    }
}

export default PhysiotherapyRequestDetails;